<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">投诉录入</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="事发地" prop="address">
                <el-input v-model="data.address" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉来源" prop="platform">
                <el-select
                  v-model="data.platform"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉对象" prop="becomplained">
                <el-input
                  v-model="data.becomplained"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉内容" prop="content">
                <el-input
                  v-model="data.content"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item
                label="图片证据"
                class="uploadfile"
                prop="productimages"
              >
                <el-upload
                  list-type="picture-card"
                  action="#"
                  :before-upload="beforeUploadImg"
                  :on-remove="onRemoveFile"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  :disabled="!IsEdit"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="name">
                <el-input v-model="data.name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人电话" prop="phone">
                <el-input v-model="data.phone" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import fileApi from "@/request/fileApi.js";
import ZJApp from "../../../../../app";
import ComplaintApi from "../../../apis/src/ComplaintApi";
import utils from "../../../../../../utils";

export default {
  name: "ComplaintInfo",
  controller: "UI",
  action: "ComplaintInfo",
  data() {
    return {
      data: {},
      upLoadUrl: "",
      ComplaintSource: "",
      // 上传图片数组
      fileImgList: [],
      newImgFileList: [],
      imgArr: [],
      fileList: [],
      ComplaintSourceArr: [
        { value: 1, label: "app安卓" },
        { value: 2, label: "appiOS" },
        { value: 3, label: "官网" },
        { value: 4, label: "公众号" },
        { value: 5, label: "小程序" },
        { value: 6, label: "其他" },
      ],

      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,

      rules: {
        address: [{ required: true, message: "请输入事发地", trigger: "blur" }],
        content: [
          { required: true, message: "请输入投诉内容", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [
          { required: true, validator: this.validphone, trigger: "blur" },
        ],

        platform: [
          { required: true, message: "请选择投诉来源", trigger: "change" },
        ],
      },
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },

  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    validphone: function (rule, value, callback) {
      console.log("validphone");
      if (!value) {
        callback(new Error("请输入联系方式"));
      } else if (!utils.isRightMobileNum(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        ComplaintApi.GetSuggestDetail(InfoId)
          .then((r) => {
            r = r.data;
            this.data = r;
            this.fileList =
              this.data.productimages == null || this.data.productimages == ""
                ? []
                : this.data.productimages.split(",");

            this.fileList = this.fileList.map((item) => ({
              url: item,
            }));
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    // 上传图片前
    beforeUploadImg(file) {
      let reg = ["jpg", "png", "jpeg", "pic", "tif", "bmp", "gif"];
      return this.beforeUpload(file, "img", reg);
    },
    uploadFileImg(params) {
      this.uploadFile(params, (data) => {
        this.fileImgList.push(data);
        this.newImgFileList.push(data);
        this.imgArr.push(data.src);

        this.$message({
          type: "success",
          message: "上传文件成功",
        });
      });
    },
    // 上传文件前
    beforeUpload(file, type, reg) {
      let FileExt = file.name.replace(/.+\./, "");

      if (reg.indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "error",
          message:
            "上传文件只能是 " + reg.lenght > 0
              ? reg.split(",")
              : JSON.stringify(reg) + "格式",
        });
        return false;
      }
    },
    // 上传文件
    uploadFile(params) {
      const _file = params.file;

      fileApi
        .uploadFile(_file)
        .then((r) => {
          if (r.code == 0 && r.data) {
            let data = r.data;
            this.fileImgList.push(data);
            this.newImgFileList.push(data);
            this.imgArr.push(data.src);
          }

          this.$message({
            type: "success",
            message: r.msg == "成功" ? "上传文件成功" : "上传失败，请重新上传",
          });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: "上传失败，请重新上传",
          });
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 删除文件
    onRemoveFile(file) {
      let fileID = "";
      let fileIndex = "";
      this.fileImgList.forEach((item, index) => {
        if (file.name === item.filename) {
          fileID = item.fileid;
          fileIndex = index;
        }
      });
      this.fileImgList.splice(fileIndex, 1);
      this.imgArr.splice(fileIndex, 1);
      if (fileID) {
        fileApi
          .deleteFile(fileID)
          .then((r) => {
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.fileImgList.length > 0) {
        this.data.productimages = this.imgArr.join(",");
      }
      if (this.$route.query.type == "edit") {
        ComplaintApi.SuggestUpdate(this.data)
          .then((r) => {
            r = r.msg;
            this.$message({
              type: "success",
              message: r == "成功" ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        ComplaintApi.SuggestAdd(this.data)
          .then((r) => {
            r = r.msg;
            this.$message({
              type: "success",
              message: r == "成功" ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function () {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
  },
};
</script>
